module.exports = __webpack_public_path__ + "static/media/game-display-2@768.fe07f172.png";